import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import Loader from "../../../utils/Loader";
import { fill_action } from "../../../actions/fillList_action";
import {
  downloadReport,
  roleActionId,
  sessionExpireMessage,
  StatusActionId,
  toastError,
  tokenInavlidMessage,
} from "../../../utils/constants";
import Modal from "react-modal";
import { ToastContainer, toast } from "react-toastify";
import Pagination from "../../../utils/pagination";
import moment from "moment";
import Header from "../../../common_components/Header";
import {
  credit_note_list_action,
  credit_note_delete_action,
  download_creditNote_action,
} from "../../../actions/accounts_action/account_credit_note_action";
import { DateRange } from "react-date-range";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

class AccountCreditNoteList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isAccordionExpanded: false,
      userId: "",
      OrderID: "",
      CreditNoteNo: "",
      CreditNoteDate: "",
      CompanyName: "",
      TotalAmount: "",
      StatusID: "",
      Status: "",
      currentPage: 1,
      PrimaryEmailID:"",
      CreditNoteList: [],
      FromDate:"",
      ToDate:"",
      dateRange: [
        {
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection'
        }
    ],
    };
    this.editCreditNavigate = this.editCreditNavigate.bind(this);
    this.getCreditNoteList = this.getCreditNoteList.bind(this);
    this.creditRecord = this.creditRecord.bind(this);
    this.updateItem = this.updateItem.bind(this);
  }
  componentDidMount() {
    const { userId } = this.state;
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      console.log("log");
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }
    this.setState({
      userId:
        sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
    });
    this.getCreditNoteList();
    setTimeout(() => {
      {
          sessionStorage.getItem("roleId") == 4 ?
              this.props.navigate('/checkList') :
              <></>
      }
     }, 10);
  }
  
  editCreditNavigate(CreditNoteID,PrimaryEmailID,RoleID) {
    this.props.navigate("/creditNoteau", {
      state: {
        CreditNoteID: CreditNoteID,
        PrimaryEmailID:PrimaryEmailID,
        RoleID:RoleID,
        isEdit:1
      },
    });
  }
  getCreditNoteList = async () => {
    const {
      CreditNoteList,
      userId,
      CreditNoteNo,
      FromDate,ToDate,
      CompanyName,
      StatusID,
    } = this.state;
    this.setState({ isLoading: true });
    this.props
      .credit_note_list_action(        
        CreditNoteNo,
        FromDate,ToDate,
        CompanyName,
        StatusID
      )
      .then((data) => {
        console.log(data);
        if (data.error !== 1) {
          this.setState({
            CreditNoteList: data.data,
            isLoading: false,
            currentpage: 1,
          });
        } else {
          if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/normalView')
            setTimeout(() => {
              toast.error(data.msg, {
                position:"top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
        }else{
          toast.error(data.msg, {
            position:"top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
        }}
      })
      .catch((e) => {
        console.log(e);
      });
    setTimeout(() => {
      console.log(CreditNoteList);
    }, 500);
  };
  chooseDate(item) {
    this.setState({ dateRange: [item.selection] });
    console.log(item, item.selection);
    this.setState({
      FromDate:
        item.selection["startDate"] != null ? (
          moment(item.selection["startDate"]).format("YYYY-MM-DD")
        ) : (
          <></>
        ),
      ToDate:
        item.selection["endDate"] != null ? (
          moment(item.selection["endDate"]).format("YYYY-MM-DD")
        ) : (
          <></>
        ),
    });
    console.log(moment(item.selection["startDate"]).format("YYYY-MM-DD"), moment(item.selection["endDate"]).format("YYYY-MM-DD"))
  }
  handleDelete(CreditNoteID) {
    const { userId } = this.state;
    const confirmed = window.confirm(
      "Are you sure you want to delete this Credit Note?"
    );
    if (confirmed) {
      this.props
        .credit_note_delete_action(CreditNoteID)
        .then((data) => {
          if (data.error !== 1) {
            toast.success("Data Deleted Successfully", {
              position:"top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
            this.getCreditNoteList(); // Refresh the holiday list after deletion
          } else {
            if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(data.msg, {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
          }else{
            toast.error(data.msg, {
              position:"top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }}
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }
  downloadCreditNote(CreditNoteID, CreditNoteNo) {
    const { userId } = this.state;
    this.setState({ isLoading: true });
    if (CreditNoteID) {
      console.log(CreditNoteID, CreditNoteNo);
      const formattedCreditNoteNo = CreditNoteNo.replace(/[\/-]/g, "_");
      this.props
        .download_creditNote_action(userId, CreditNoteID, formattedCreditNoteNo)
        .then((downloadData) => {
          if (downloadData.error !== 1) {
            this.setState({ isLoading: false });
            console.log(downloadData);
            const url = `${downloadReport}?SessionIdentifier=${downloadData}&Export=true`;
            window.open(url, "_blank");
          } else {
            if(downloadData.msg == sessionExpireMessage || downloadData.msg == tokenInavlidMessage){
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(downloadData.msg, {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
          }else{
            this.setState({ isLoading: false });
            toast.error(downloadData.msg,{
              position:"top-center",theme:"colored",autoClose:1000,hideProgressBar:true});
          }}
        })
        .catch((err) => {
          console.log(err);
          this.setState({ isLoading: false });
        });
    } else {
      this.setState({ isLoading: false });
      toast.error("Cannot download: CreditNoteID not found.",{
        position:"top-center",theme:"colored",autoClose:1000,hideProgressBar:true});
    }
  }
  updateItem(item) {
    console.log("updateItem : ", item);
    this.setState({ currentPage: item });
  }
  creditRecord(CreditNoteList) {
    return (
      <table class="table table-bordered table-striped" id="dashboard-table">
        <thead>
          <tr>
            <th>Credit Note No</th>
            <th>Credit Note Date</th>
            <th>Company</th>
            <th>Order No</th>
            <th>Credit Note Amount</th>
            <th>Status</th>
            <th class="text-right" style={{ width: "8%" }}>
              Action
            </th>
          </tr>
        </thead>
        <tbody id="myTable">
          {CreditNoteList.length > 0 ? (
            CreditNoteList.map((data, i) => (
              <tr>
                <td>{data.CreditNoteNo}</td>
                <td>
                  {data.CreditNoteDate
                    ? moment(data.CreditNoteDate).format("DD-MM-YYYY")
                    : null}
                </td>
                <td>{data.CompanyName}</td>
                <td>{data.OrderNo?data.OrderNo:"Not Available"}</td>
                <td>{data.TotalAmount?.toLocaleString("en-IN")}</td>
                <td>{data.Status}</td>
                <td class="text-right">
                  <a
                    title="Download PDF"
                    href="javascript:void(0);"
                    class="btn btn-sm padding_0"
                    onClick={() =>
                      this.downloadCreditNote(
                        data.CreditNoteID,
                        data.CreditNoteNo
                      )
                    }
                  >
                    <i class="fa fa-file-pdf-o action_btn_table"></i>
                  </a>
                  <a
                    onClick={() => this.editCreditNavigate(data.CreditNoteID,data.PrimaryEmailID,data.RoleID)}
                    href="javascript:void(0);"
                    title="Edit"
                    class="btn btn-sm"
                  >
                    <i class="fa fa-edit action_btn_table"></i>
                  </a>
                  <a
                    href="javascript:void(0);"
                    title="Delete"
                    class="btn btn-sm delete_record"
                    onClick={() => this.handleDelete(data.CreditNoteID)}
                  >
                    <i class="fa fa-trash action_btn_table"></i>
                  </a>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8">No data available.</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }
  render() {
    const {
      isLoading,
      isAccordionExpanded,FromDate,ToDate,
      userId,
      OrderID,
      CreditNoteNo,
      CreditNoteDate,
      CompanyName,
      StatusID,
      CreditNoteList,
      TotalAmount,
      Status,
      currentPage,
    } = this.state;

    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = CreditNoteList.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(CreditNoteList.length / recordsPerPage);
    return (
      <>
        {isLoading ? (
          <Loader></Loader>
        ) : (
          <>
            <main id="main">
              <Header data={[12]} />

              <section style={{ marginTop: "115px" }}>
                <div class="container-fluid">
                  <div class="page-header">
                    <h4 class="page-title">Credit Note</h4>
                    {/* <div>
                      <a
                        href="javascript:void(0);"
                        onClick={()=>this.props.navigate('/creditNoteau')}
                        class="btn btn-primary btn-sm create_btn"
                      >
                        <i class="fa fa-plus"></i>{" "}
                        <span class="hidden-xs">Add</span>
                      </a>
                    </div> */}
                  </div>

                  <div class="search_accordion search_card">
                    <div class="panel-group" id="accordion">
                      <div class="panel panel-default">
                        <div
                          className="panel-heading accordion-toggle collapsed"
                          data-toggle="collapse"
                          data-parent="#accordion"
                          data-target="#collapseOne"
                          aria-expanded={isAccordionExpanded}
                          onClick={() =>
                            this.setState({
                              isAccordionExpanded: !isAccordionExpanded,
                            })
                          }
                        >
                          <h4 class="panel-title">Search</h4>

                          <div class="searched_items">
                          <h5>
                            Credit Note Date :{" "}
                            <span>
                              {FromDate != "" && FromDate != "null" ? (
                                moment(FromDate).format("DD-MM-YYYY")
                              ) : (
                                <></>
                              )}{" "}
                              &nbsp; - &nbsp;
                              {ToDate != "" && ToDate != "null" ? (
                                moment(ToDate).format("DD-MM-YYYY")
                              ) : (
                                <></>
                              )}
                            </span>
                            </h5>
                            <h5>
                              Credit Note No : <span>{CreditNoteNo}</span>
                            </h5>
                            <h5>
                              Company : <span>{CompanyName}</span>
                            </h5>
                            {/* <h5>
                              Status : <span>{Status}</span>
                            </h5> */}
                          </div>
                        </div>
                        <div
                          id="collapseOne"
                          className={`panel-collapse collapse ${
                            isAccordionExpanded ? "show" : ""
                          }`}
                        >
                          <div class="panel-body">
                            <div class="row mr_0">
                            <div class="col-md-3">
                                                                <div class="form-group">
                                                                    <label>CreditNote Date</label>
                                                                    <DateRange
                                                                        editableDateInputs={true}
                                                                        onChange={(item) => this.chooseDate(item)}
                                                                        moveRangeOnFirstSelection={false}
                                                                        ranges={this.state.dateRange}
                                                                    />
                                                                </div>
                                                            </div>
                              <div class="col-md-2">
                                <div class="form-group">
                                  <label>Credit Note No</label>
                                  <input
                                    type="text"
                                    value={CreditNoteNo}
                                    onChange={(e)=>this.setState({CreditNoteNo:e.target.value})}
                                    class="form-control search_form_control"
                                    placeholder="Credit Note No"
                                  />
                                </div>
                              </div>
                             
                              <div class="col-md-2">
                                <div class="form-group">
                                  <label>Company</label>
                                  <input
                                    type="text"
                                    value={CompanyName}
                                    onChange={(e)=>this.setState({CompanyName:e.target.value})}
                                    class="form-control search_form_control"
                                    placeholder="Enter Company"
                                  />
                                </div>
                              </div>
                              {/* <div class="col-md-2">
                                <div class="form-group">
                                  <label>Status</label>
                                  <select class="form-control">
                                    <option value="Active" selected>Active</option>
                                    <option value="Inactive">Inactive</option>
                                  </select>
                                </div>
                              </div> */}
                              <div class="col-md-1">
                                <label>&nbsp;</label>
                                <a href="javascript:void(0);" onClick={()=>this.getCreditNoteList()} class="btn btn-primary search_btn mr-2">
                                  Search
                                </a>
                              </div>
                              <div class="col-md-1">
                              <label>&nbsp;</label>
                                <a href="javascript:void(0);" onClick={()=>window.location.reload()} class="btn btn-primary search_btn">
                                  Clear
                                </a>
                              </div>
                              
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="custom_table">
                    <div class="hack1">
                      <div class="hack2">
                        {this.creditRecord(currentRecords)}
                        <Pagination
                          nPages={nPages}
                          currentPage={currentPage}
                          setCurrentPage={this.updateItem}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </main>
            <ToastContainer />
          </>
        )}
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    fill_action,
    credit_note_list_action,
    credit_note_delete_action,
    download_creditNote_action,
  })(AccountCreditNoteList)
);
